'use strict';

var _themeAddresses = require('@shopify/theme-addresses');

var selectors = {
  addressContainer: '[data-address]',
  addressFields: '[data-address-fields]',
  addressToggle: '[data-address-toggle]',
  addressForm: '[data-address-form]',
  addressDeleteForm: '[data-address-delete-form]'
}; /**
    * Customer Addresses Script
    * ------------------------------------------------------------------------------
    * A file that contains scripts highly couple code to the Customer Addresses
    * template.
    *
    * @namespace customerAddresses
    */

var hideClass = 'hide';

var options = {
  shippingCountriesOnly: true
};

function initializeAddressForm(container) {
  var addressFields = container.querySelector(selectors.addressFields);
  var addressForm = container.querySelector(selectors.addressForm);
  var deleteForm = container.querySelector(selectors.addressDeleteForm);

  container.querySelectorAll(selectors.addressToggle).forEach(function (button) {
    button.addEventListener('click', function () {
      addressForm.classList.toggle(hideClass);
    });
  });

  (0, _themeAddresses.AddressForm)(addressFields, 'nl', options);

  if (deleteForm) {
    deleteForm.addEventListener('submit', function (event) {
      var confirmMessage = deleteForm.getAttribute('data-confirm-message');

      if (!window.confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
        event.preventDefault();
      }
    });
  }
}

var addressForms = document.querySelectorAll(selectors.addressContainer);

if (addressForms.length) {
  addressForms.forEach(function (addressContainer) {
    initializeAddressForm(addressContainer);
  });
}